import '../../app.es6';
import angular from 'angular';
import moment from '../../../node_modules/moment/moment.js';

class CoachTopController {
  /* @ngInject */
  constructor (
    $scope, $sessionStorage, $location,
    commonApiFactory, commonFactory, Const, Page
  ) {
    this.Const = Const;
    this.$scope = $scope;
    this.$sessionStorage = $sessionStorage;
    this.$sessionStorage[this.Const.SSAPP_HAS_HEADER] = true;
    this.$sessionStorage[this.Const.SSAPP_HAS_GRAY] = 'gray';
    this.$sessionStorage[this.Const.SSAPP_MIN_HEIGHT] = '';
    this.$location = $location;
    this.commonApiFactory = commonApiFactory;
    this.commonFactory = commonFactory;
    this.commonFactory.overlayHidden();
    this.commonFactory.deleteErrorFlg();
    this.$sessionStorage[this.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] = '';

    let role = localStorage.getItem(this.Const.LSAPP_ROLE);
    if (role === this.Const.LSAPP_ROLE_MEMBER) {
      this.$location.path('/member');
    } else if (role === this.Const.LSAPP_ROLE_C_ADMIN) {
      this.$location.path('/admin/school');
    } else if (role === this.Const.LSAPP_ROLE_S_ADMIN) {
      this.$location.path('/admin');
    }

    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    } else {
      this.commonFactory.overlayShow();
    }

    let today = new Date();
    this.currentDate = today;
    this.monthRange = this.commonFactory.getMonthRange(today);
    this.selectedYearMonth = moment().format('YYYY年M月');
    this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;

    // 画面に表示するリスト
    this.courseList = [];
    // 全データ格納用リスト
    this.allList = [];
    this.commonApiFactory.getStaffsMeCourses()
    .then((result) => {
      return result.forEach((d) => {
        if (d.schoolId === this.$sessionStorage[this.Const.SSAPP_SCHOOL_ID]) {
          this.allList.push(d);
        }
      });
    })
    .then(() => {
      let that = this;
      // 表示の基準となる期間を取得
      let begin = this.monthRange.beginDateParam;
      let end = this.monthRange.endDateParam;
      return this.squeezeCourse(that, begin, end);
    })
    .then(() => {
      this.existenceFlg = true;
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    })
    .catch((error) => {
      this.existenceFlg = false;
      console.error('error : ', error);
      this.commonFactory.overlayHidden();
      this.$scope.$apply();
    });

    Page.setTitle(this.Const.TITLE.topForStaff);

    CoachTopController.$inject = [
      '$scope', '$sessionStorage', '$location',
      'commonApiFactory', 'commonFactory', 'Const', 'Page'
    ];
  }

  // 指定された期間に該当するコースを絞る
  squeezeCourse (that, begin, end) {
    return new Promise(function (resolve, reject) {
      that.allList.forEach((d) => {
        // コースの期間を変換
        let courseStart = new Date(d.startedDate);
        let courseEnd = new Date(d.endedDate);
        courseStart = courseStart.toISOString();
        courseEnd = courseEnd.toISOString();
        // 表示対象を絞る
        if (courseStart < begin && courseEnd > end) {
          let courseObj = {
            schoolName: d.schoolName,
            courseId: d.id,
            courseName: d.name
          };
          that.courseList.push(courseObj);
        } else if (courseEnd >= begin && courseEnd <= end) {
          let courseObj = {
            schoolName: d.schoolName,
            courseId: d.id,
            courseName: d.name
          };
          that.courseList.push(courseObj);
        } else if (courseStart >= begin && courseStart <= end) {
          let courseObj = {
            schoolName: d.schoolName,
            courseId: d.id,
            courseName: d.name
          };
          that.courseList.push(courseObj);
        }
        that.$sessionStorage[that.Const.SSAPP_COURSE_LIST] = that.courseList;
      });
      if (that.courseList.length > 0) {
        return resolve();
      } else {
        return reject();
      }
    });
  }

  toCourseDetail (obj, idx) {
    this.$sessionStorage[this.Const.SSAPP_COURSE_INDEX] = idx;
    this.$sessionStorage[this.Const.SSAPP_SCHOOL_NAME] = obj.schoolName;
    // 次の画面でコースを受講している生徒を取得するために必要
    this.$sessionStorage[this.Const.SSAPP_COURSE_ID] = obj.courseId;
    this.$location.path('/staff/course');
  }

  // 基準からみて次の月に該当するコースを表示する
  toNextMonth () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }

    let currentDate = this.currentDate;
    let nextMonthRnage = this.commonFactory.getMonthLater(currentDate);
    // 次の月を基準とする
    this.currentDate = new Date(nextMonthRnage.beginDateParam);
    this.selectedYearMonth = moment(this.currentDate).format('YYYY年M月');
    this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
    let that = this;
    let begin = nextMonthRnage.beginDateParam;
    let end = nextMonthRnage.endDateParam;
    this.courseList = [];
    this.squeezeCourse(that, begin, end)
    .then(() => {
      this.existenceFlg = true;
      this.$scope.$apply();
    })
    .catch(() => {
      this.existenceFlg = false;
      this.$scope.$apply();
    });
  }

  // 基準からみて前の月に該当するコースを表示する
  tobeforeMonth () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }

    let currentDate = this.currentDate;
    let beforeMonthRnage = this.commonFactory.getMonthAgo(currentDate);
    // 前の月を基準とする
    this.currentDate = new Date(beforeMonthRnage.beginDateParam);
    this.selectedYearMonth = moment(this.currentDate).format('YYYY年M月');
    this.$sessionStorage[this.Const.SSAPP_SELECTED_YEAR_MONTH] = this.selectedYearMonth;
    let that = this;
    let begin = beforeMonthRnage.beginDateParam;
    let end = beforeMonthRnage.endDateParam;
    this.courseList = [];
    this.squeezeCourse(that, begin, end)
    .then(() => {
      this.existenceFlg = true;
      this.$scope.$apply();
    })
    .catch(() => {
      this.existenceFlg = false;
      this.$scope.$apply();
    });
  }

  // 全クラス一覧ボタン押下
  toCourseListAll () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$sessionStorage[this.Const.SSAPP_SELECTED_DATE] = this.currentDate;
    this.$sessionStorage[this.Const.SSAPP_ADMIN_COURSE_LIST_LOCATION] = this.Const.ADMIN_COURSE_LIST_LOCATION.coachTop;
    this.$location.path('/admin/course');
  }

  // ゲスト動画一覧ボタン押下
  toGuestDetailList () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$location.path('/staff/guest_video');
  }

  // 動画公開状況ボタン押下
  toVideoBacklog () {
    if (!navigator.onLine) {
      this.commonFactory.flashErrorMessageFlag(this.Const.SSAPP_HAS_NETWORK_ERROR, 3000, false);
      return;
    }
    this.$location.path('/staff/video_backlog');
  }
}

angular.module('myApp').controller('CoachTopController', CoachTopController);



// WEBPACK FOOTER //
// ./app/components/coach-top/coach-top-controller.es6